export type AnyClass<T> = new (...args: any[]) => T;

export class ServiceRegistry<T> {
    private map = new Map<Function, T>();

    add<C extends AnyClass<T>>(
        chan: C,
        ...args: ConstructorParameters<C>
    ): InstanceType<C> {
        if (this.map.has(chan)) {
            return this.map.get(chan) as InstanceType<C>;
        }
        const sys = new chan(...args) as InstanceType<C>;
        this.map.set(chan, sys);
        return sys;
    }

    has<C extends AnyClass<T>>(chan: C): boolean {
        const sys = this.map.get(chan) as InstanceType<C>;
        if (!sys) return false;
        return true;
    }

    // Get a system by class
    get<C extends AnyClass<T>>(chan: C): InstanceType<C> {
        const sys = this.map.get(chan);
        if (!sys) throw new Error(`Channel not found: ${chan.name}`);
        return sys as InstanceType<C>;
    }

    forEach(fn: (val: T) => void) {
        this.map.forEach((val) => {
            fn(val)
        })
    }

    forEachExcept<C extends T>(ctor: AnyClass<C>, fn: (val: T) => void): C {
        let comp: C = null;

        this.map.forEach((val) => {
            if (val instanceof ctor) comp = val as unknown as C;
            else fn(val);
        });

        return comp;
    }
}